import './lib/payments'